// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import AutoSubmitController from './auto_submit_controller'
application.register('auto-submit', AutoSubmitController)

import NavbarController from './navbar_controller'
application.register('navbar', NavbarController)

import ToastController from './toast_controller'
application.register('toast', ToastController)

import ChartController from './chart_controller'
application.register('chart', ChartController)

import ClipboardController from './clipboard_controller'
application.register('clipboard', ClipboardController)

import CollapseController from './collapse_controller'
application.register('collapse', CollapseController)

import ConfettiController from './confetti_controller'
application.register('confetti', ConfettiController)

import DomainInputController from './domain_input_controller'
application.register('domain-input', DomainInputController)

import TooltipController from './tooltip_controller'
application.register('tooltip', TooltipController)
